// extracted by mini-css-extract-plugin
export default {"container":"Inflation_container__FxNbo"};